import { Attributes } from '@leverege/ui-attributes'
import getStage from '../../../util/Stage'

// eslint-disable-next-line import/prefer-default-export
export function lineHasActiveHalf( line ) {
  const uw = line.data?.data?.uwMold
  const lw = line.data?.data?.lwMold

  const stageUw = Attributes.get( 'moldHalf.currentStage', 'moldHalf', uw )
  const stageLw = Attributes.get( 'moldHalf.currentStage', 'moldHalf', lw )

  const { name : nameUw } = getStage( stageUw )
  const { name : nameLw } = getStage( stageLw )

  return nameUw !== 'Inactive' || nameLw !== 'Inactive'
}

export function sortLinesByActivity( line1, line2 ) {
  const line1Active = lineHasActiveHalf( line1 )
  const line2Active = lineHasActiveHalf( line2 )
  if ( line1Active && !line2Active ) {
    return -1
  }
  if ( !line1Active && line2Active ) {
    return 1
  }
  const name1 = Attributes.get( 'name', line1.type, line1 )
  const name2 = Attributes.get( 'name', line2.type, line2 )
  if ( name1 === name2 ) {
    return 0
  }
  return name1 > name2 ? 1 : -1
}
